<template>
  <modal @before-open="beforeOpen" @before-close="beforeClose" @opened="opened" name="verifyModal" :draggable="'.header'" :reset="true"
         :classes="['verifyModal','generalbox']" :adaptive="true"
          :height="'80%'" :width="'80%'" :max-width="1540" :max-height="885" :min-width="1092"
         :min-height="614" :click-to-close="false">
    <div @click="close" class="close">
      <i class="iconfont icon-cha"></i>
    </div>
    <div class="header">
      <h2>资料审核</h2>
    </div>
    <div class="content">
      <verify-list :preData="preData"></verify-list>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config'
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';

  import verifyList from 'components/profileVerify/verifyList'
  
  export default {
    name: "verifyModal",
    data() {
      return {
        preData: -1
      }
    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        this.$modal.hide("verifyModal");
      },
      beforeOpen(data) {
        if (data.params.preData) {
          this.preData = data.params.preData
        }
      },
      opened(){
        this.updateModalZIndex(this.$el)
      },
      beforeClose(){
        this.preData=null
      }
    },
    computed: {},
    mounted() {
    },
    components: {verifyList}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
</style>


// WEBPACK FOOTER //
// src/components/profileVerify/verifyModal.vue